import {
  BrowserCacheLocation,
  type Configuration,
  LogLevel,
  type RedirectRequest,
} from "@azure/msal-browser";

const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID;
const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID;
const apiScope = import.meta.env.VITE_API_SCOPE;

if (!clientId || !tenantId || !apiScope) {
  throw new Error(
    "Missing Entra configuration. Check VITE_ENTRA_CLIENT_ID, " +
      "VITE_ENTRA_TENANT_ID and VITE_API_SCOPE.",
  );
}

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }

        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
        }
      },
    },
  },
};

export const loginRequest: RedirectRequest = {
  scopes: ["openid", "profile", "email", apiScope],
};

export const tokenRequest = {
  scopes: [apiScope],
};